var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDrone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 213,
    viewBox: "0 0 444 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.425 166.04H194.993V196.497H201.425V166.04Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.425 179.763H194.993V196.496H201.425V179.763Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.434 166.04H241.002V196.497H247.434V166.04Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.434 179.763H241.002V196.496H247.434V179.763Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.247 166.04V198.716C241.247 201.737 239.554 204.478 236.917 205.717C234.929 206.655 232.774 207.144 230.592 207.144H212.084C209.902 207.144 207.747 206.655 205.753 205.717C203.122 204.478 201.422 201.737 201.422 198.716V166.04L221.335 165.544L241.247 166.04Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.247 166.04V174.2C241.247 177.222 239.554 179.962 236.917 181.208C234.929 182.146 232.774 182.629 230.592 182.629H212.084C209.902 182.629 207.747 182.146 205.753 181.208C203.122 179.962 201.422 177.222 201.422 174.2V166.04L221.335 165.544L241.247 166.04Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.458 185.849H212.21C210.009 185.849 208.224 187.636 208.224 189.839V200.429C208.224 202.633 210.008 204.42 212.21 204.42H230.458C232.66 204.42 234.445 202.634 234.445 200.429V189.839C234.445 187.636 232.66 185.849 230.458 185.849ZM229.952 197.247C229.952 199.451 228.167 201.237 225.965 201.237H216.704C214.503 201.237 212.718 199.451 212.718 197.247V193.022C212.718 190.818 214.502 189.031 216.704 189.031H225.965C228.167 189.031 229.952 190.818 229.952 193.022V197.247Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.335 198.477C223.94 198.477 226.053 196.363 226.053 193.754C226.053 191.146 223.94 189.031 221.335 189.031C218.729 189.031 216.617 191.146 216.617 193.754C216.617 196.363 218.729 198.477 221.335 198.477Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.102 171.937C398.102 171.937 383.939 210.316 382.961 211.294C381.985 212.271 380.519 212.027 379.298 211.783C378.077 211.538 374.17 209.338 373.437 208.116C372.704 206.894 373.681 205.672 374.169 203.471C374.658 201.271 383.693 171.692 383.693 171.692L396.392 168.759L398.102 171.937Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M400.544 155.803L399.35 169.952C399.164 172.157 397.854 174.1 395.893 175.122C393.347 176.451 389.53 177.942 385.404 177.804C378.077 177.56 370.996 169.982 365.623 166.315C360.25 162.648 346.331 158.493 339.004 157.026C331.678 155.559 284.79 146.269 281.371 143.581C277.952 140.892 274.288 137.225 273.067 136.491C271.847 135.758 263.787 135.269 263.787 135.269L262.566 118.157L395.416 156.536L400.544 155.803Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.787 110.824C263.787 110.824 272.579 115.958 278.928 117.914C285.277 119.869 292.36 119.38 292.36 119.38C292.36 119.38 397.369 150.67 399.079 151.159C400.788 151.648 402.009 158.737 398.102 162.893C394.195 167.049 384.182 167.049 380.275 164.604C376.368 162.159 369.042 155.559 368.309 155.07C367.577 154.581 288.697 129.647 285.522 128.425C282.347 127.203 278.44 125.98 277.707 125.98C276.974 125.98 268.916 125.003 266.962 124.025C265.008 123.047 263.787 110.824 263.787 110.824Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M274.053 116.054C268.841 113.775 263.787 110.824 263.787 110.824C263.787 110.824 265.008 123.047 266.962 124.025C268.916 125.002 276.974 125.98 277.707 125.98C277.822 125.98 278.023 126.013 278.279 126.069L274.053 116.054Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.146 143.4V154.802C375.146 159.001 381.052 162.404 388.336 162.404C395.62 162.404 401.526 159.001 401.526 154.802V143.4H375.146Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.336 151.002C395.621 151.002 401.526 147.598 401.526 143.4C401.526 139.202 395.621 135.799 388.336 135.799C381.051 135.799 375.146 139.202 375.146 143.4C375.146 147.598 381.051 151.002 388.336 151.002Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M385.598 137.614L394.97 130.552L398.242 133.576L398.752 143.4C398.752 146.716 394.088 149.403 388.335 149.403C382.582 149.403 377.919 146.716 377.919 143.4C377.92 140.632 381.176 138.308 385.598 137.614Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M435.222 87.1124C435.222 87.1124 441.815 94.2016 440.839 96.8903C439.862 99.5791 413.731 125.002 411.045 126.225C408.359 127.447 402.986 130.625 402.986 130.625L387.845 143.581C387.845 143.581 387.357 160.692 383.694 164.359C380.03 168.026 341.69 187.827 341.201 189.538C340.712 191.249 340.224 192.471 339.003 192.716C337.782 192.96 333.63 188.56 332.165 185.137C330.7 181.715 330.7 180.737 332.165 178.537C333.63 176.337 365.377 144.803 367.087 143.336C368.796 141.869 373.192 142.602 375.878 140.891C378.564 139.18 391.752 128.913 391.752 127.935C391.752 126.958 390.287 125.002 392.241 123.046C394.195 121.091 429.117 93.9564 430.093 91.5123C431.07 89.0681 430.337 87.1124 431.314 86.3787C432.291 85.6457 435.222 87.1124 435.222 87.1124Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M394.784 128.855L396.5 129.376C397.964 129.82 398.391 131.689 397.265 132.726L389.758 139.639C388.414 140.878 386.534 141.35 384.763 140.895L382.27 140.253C380.892 139.898 380.462 138.151 381.518 137.196L389.404 130.061C390.861 128.743 392.903 128.285 394.784 128.855Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.166 185.137C330.7 181.715 330.7 180.737 332.166 178.537C332.283 178.36 332.598 177.992 333.075 177.469L340.155 191.987C339.855 192.361 339.489 192.618 339.004 192.715C337.783 192.96 333.631 188.56 332.166 185.137Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M440.839 96.8903C441.815 94.2016 435.222 87.1124 435.222 87.1124C435.222 87.1124 432.291 85.6457 431.314 86.3794C430.337 87.1124 431.07 89.0681 430.093 91.5129L439.197 99.0926C440.114 98.0287 440.708 97.2508 440.839 96.8903Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1989 171.937C45.1989 171.937 59.3634 210.316 60.3399 211.294C61.3165 212.271 62.7823 212.027 64.0032 211.783C65.224 211.538 69.1316 209.338 69.8645 208.116C70.5968 206.894 69.6202 205.672 69.1316 203.471C68.643 201.271 59.6077 171.692 59.6077 171.692L46.9091 168.759L45.1989 171.937Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7565 155.803L43.9506 169.952C44.1367 172.157 45.4466 174.1 47.4071 175.122C49.9539 176.451 53.7704 177.942 57.8969 177.804C65.2234 177.56 72.3049 169.982 77.6777 166.315C83.0504 162.648 96.9699 158.493 104.296 157.026C111.623 155.558 158.511 146.269 161.93 143.581C165.349 140.892 169.012 137.225 170.233 136.491C171.454 135.758 179.513 135.269 179.513 135.269L180.734 118.157L47.8843 156.536L42.7565 155.803Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.513 110.824C179.513 110.824 170.722 115.958 164.372 117.914C158.023 119.869 150.941 119.38 150.941 119.38C150.941 119.38 45.9312 150.67 44.2217 151.159C42.5122 151.648 41.2914 158.737 45.1983 162.893C49.1058 167.049 59.1184 167.049 63.0253 164.604C66.9328 162.159 74.2587 155.559 74.9916 155.07C75.7245 154.581 154.603 129.647 157.779 128.425C160.954 127.203 164.861 125.98 165.593 125.98C166.326 125.98 174.385 125.003 176.339 124.025C178.293 123.047 179.513 110.824 179.513 110.824Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1544 143.4V154.802C68.1544 159.001 62.2489 162.404 54.9645 162.404C47.6802 162.404 41.7746 159.001 41.7746 154.802V143.4H68.1544Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9645 151.002C62.2491 151.002 68.1544 147.598 68.1544 143.4C68.1544 139.202 62.2491 135.799 54.9645 135.799C47.6799 135.799 41.7746 139.202 41.7746 143.4C41.7746 147.598 47.6799 151.002 54.9645 151.002Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7021 137.614L48.3307 130.552L45.0584 133.576L44.549 143.4C44.549 146.716 49.2123 149.403 54.9652 149.403C60.7181 149.403 65.3813 146.716 65.3813 143.4C65.3807 140.632 62.1244 138.308 57.7021 137.614Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07904 87.1124C8.07904 87.1124 1.48544 94.2016 2.462 96.8903C3.43856 99.5791 29.5693 125.002 32.2554 126.225C34.9414 127.447 40.3141 130.625 40.3141 130.625L55.4551 143.581C55.4551 143.581 55.9437 160.692 59.607 164.359C63.2703 168.026 101.611 187.827 102.1 189.538C102.588 191.249 103.076 192.471 104.298 192.716C105.519 192.96 109.67 188.56 111.136 185.137C112.601 181.715 112.601 180.737 111.136 178.537C109.67 176.337 77.9233 144.803 76.2138 143.336C74.5044 141.869 70.1088 142.602 67.4221 140.891C64.7361 139.18 51.5489 128.913 51.5489 127.935C51.5489 126.958 53.0141 125.002 51.0603 123.046C49.1065 121.091 14.1847 93.9564 13.2081 91.5123C12.2316 89.0681 12.9638 87.1124 11.9873 86.3787C11.0094 85.6457 8.07904 87.1124 8.07904 87.1124Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9866 86.3796C11.0101 85.6459 8.07904 87.1125 8.07904 87.1125C8.07904 87.1125 1.48544 94.2018 2.462 96.8905C2.545 97.1176 2.82009 97.5197 3.23307 98.0436L12.5321 87.5923C12.4632 87.0569 12.3333 86.6395 11.9866 86.3796Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.135 185.137C112.6 181.715 112.6 180.737 111.135 178.537C111.017 178.36 110.703 177.992 110.225 177.469L103.146 191.987C103.446 192.361 103.812 192.618 104.296 192.715C105.519 192.96 109.67 188.56 111.135 185.137Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5168 128.855L46.8013 129.376C45.3368 129.82 44.9104 131.689 46.0363 132.726L53.5428 139.639C54.8875 140.878 56.7677 141.35 58.5381 140.895L61.0313 140.253C62.4095 139.898 62.8392 138.151 61.7837 137.196L53.8976 130.061C52.4398 128.743 50.3976 128.285 48.5168 128.855Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M184.775 81.9299C184.775 81.9299 117.968 59.3047 116.168 59.7053C114.367 60.106 112.367 60.7063 110.967 60.106C109.567 59.5057 93.7651 55.1004 92.7651 55.1004C91.7651 55.1004 88.3642 56.7024 88.1648 58.9047C87.9646 61.107 88.565 70.5178 89.1648 71.7191C89.7645 72.9204 96.3654 76.324 98.5655 76.324C100.766 76.324 109.367 72.5198 111.367 73.3211C113.367 74.1217 188.575 105.156 188.575 105.156L192.976 98.1486L184.775 81.9299Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5655 76.3234C96.3654 76.3234 89.7645 72.9198 89.1648 71.7184C88.7826 70.9533 88.4011 66.8616 88.2257 63.4205C93.8541 69.8974 103.847 66.1427 105.367 66.7129C106.967 67.3132 107.967 66.1126 109.567 65.1109C111.167 64.1099 113.367 63.3093 113.367 63.3093L188.339 88.9776L192.976 98.1473L188.576 105.155C188.576 105.155 113.368 74.1204 111.368 73.3197C109.367 72.5191 100.766 76.3234 98.5655 76.3234Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.601 51.2024V59.6115C110.601 62.7076 105.363 65.2174 98.8995 65.2174C92.4365 65.2174 87.1976 62.7076 87.1976 59.6115V51.2024H110.601Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8995 56.8083C105.362 56.8083 110.601 54.2984 110.601 51.2024C110.601 48.1063 105.362 45.5965 98.8995 45.5965C92.4367 45.5965 87.1976 48.1063 87.1976 51.2024C87.1976 54.2984 92.4367 56.8083 98.8995 56.8083Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6581 51.2024C89.6581 53.6472 93.7952 55.6297 98.8995 55.6297C104.003 55.6297 108.141 53.6479 108.141 51.2024C108.141 48.7575 104.004 46.775 98.8995 46.775C93.7959 46.775 89.6581 48.7575 89.6581 51.2024Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M106.491 42.9976C106.491 42.9976 107.286 45.0646 105.379 47.4498C103.473 49.835 99.6606 51.4256 97.9129 51.7431C96.1653 52.0614 92.9887 51.9019 92.9887 51.9019C92.9887 51.9019 85.9988 65.1003 83.616 66.3726C81.2332 67.6449 28.0151 88.4759 27.2213 89.2712C26.4275 90.0665 24.5205 88.7941 24.044 87.363C23.5674 85.9319 22.9322 81.6385 24.5206 80.2074C26.1089 78.7763 72.655 47.9268 74.5612 47.768C76.4675 47.6092 86.6347 47.4498 87.2699 47.1322C87.9051 46.814 156.056 5.62905 157.644 4.35672C159.233 3.08439 159.392 1.01744 160.504 0.858651C161.615 0.699861 163.522 3.24385 163.045 6.10609C162.569 8.96833 159.391 10.8765 159.391 10.8765L106.491 42.9976Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M159.762 1.35772C159.971 1.08771 160.202 0.900784 160.504 0.857904C161.615 0.699114 163.522 3.2431 163.045 6.10534C162.668 8.36726 160.611 10.0282 159.762 10.6278V1.35772Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.044 87.3629C23.5674 85.9318 22.9322 81.6385 24.5206 80.2073C24.8157 79.9413 26.6671 78.657 29.4944 76.7434L27.6316 89.0487C27.3994 89.1592 27.2561 89.2356 27.2206 89.2711C26.4268 90.0664 24.5205 88.7941 24.044 87.3629Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.833 36.2393C106.732 37.5035 106.561 40.0422 104.496 41.2388L93.6941 47.4966C92.749 48.044 91.5268 48.0326 90.6453 47.4685L89.1467 46.509C87.7183 45.5945 87.8181 43.7091 89.3415 42.8133L100.62 36.181C101.925 35.4118 103.626 35.4359 104.833 36.2393Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M259.687 81.9299C259.687 81.9299 326.494 59.3047 328.294 59.7053C330.095 60.106 332.095 60.7063 333.495 60.106C334.895 59.5057 350.697 55.1004 351.697 55.1004C352.697 55.1004 356.097 56.7024 356.297 58.9047C356.497 61.107 355.897 70.5178 355.297 71.7191C354.697 72.9204 348.096 76.324 345.896 76.324C343.696 76.324 335.095 72.5198 333.095 73.3211C331.095 74.1217 255.886 105.156 255.886 105.156L251.485 98.1486L259.687 81.9299Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M259.687 81.9299L251.486 98.1479L255.887 105.155C255.887 105.155 267.393 100.408 281.523 94.5782L268.485 78.9625C263.138 80.7608 259.687 81.9299 259.687 81.9299Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M345.896 76.3234C348.096 76.3234 354.697 72.9198 355.297 71.7184C355.679 70.9533 356.061 66.8616 356.236 63.4205C350.608 69.8974 340.615 66.1427 339.095 66.7129C337.495 67.3132 336.495 66.1126 334.894 65.1109C333.294 64.1099 331.094 63.3093 331.094 63.3093L256.122 88.9776L251.485 98.1473L255.886 105.155C255.886 105.155 331.094 74.1204 333.094 73.3197C335.095 72.5191 343.696 76.3234 345.896 76.3234Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M333.86 51.2024V59.6115C333.86 62.7076 339.099 65.2174 345.562 65.2174C352.025 65.2174 357.264 62.7076 357.264 59.6115V51.2024H333.86Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M345.562 56.8083C352.025 56.8083 357.264 54.2984 357.264 51.2024C357.264 48.1063 352.025 45.5965 345.562 45.5965C339.099 45.5965 333.86 48.1063 333.86 51.2024C333.86 54.2984 339.099 56.8083 345.562 56.8083Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M354.804 51.2024C354.804 53.6472 350.667 55.6297 345.562 55.6297C340.459 55.6297 336.321 53.6479 336.321 51.2024C336.321 48.7575 340.459 46.775 345.562 46.775C350.666 46.775 354.804 48.7575 354.804 51.2024Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M337.97 42.9975C337.97 42.9975 337.176 45.0645 339.082 47.4497C340.988 49.8349 344.801 51.4255 346.548 51.7431C348.296 52.0613 351.472 51.9018 351.472 51.9018C351.472 51.9018 358.462 65.1002 360.845 66.3725C363.228 67.6448 416.446 88.4758 417.24 89.2711C418.034 90.0664 419.941 88.7941 420.417 87.3629C420.894 85.9318 421.529 81.6385 419.941 80.2073C418.352 78.7762 371.806 47.9267 369.9 47.7679C367.994 47.6092 357.826 47.4497 357.191 47.1321C356.556 46.8145 288.407 5.6283 286.818 4.35597C285.229 3.08364 285.07 1.01669 283.958 0.857904C282.846 0.699114 280.94 3.2431 281.417 6.10534C281.893 8.96758 285.071 10.8757 285.071 10.8757L337.97 42.9975Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M284.7 1.35772C284.491 1.08771 284.26 0.900784 283.958 0.857904C282.846 0.699114 280.94 3.2431 281.417 6.10534C281.794 8.36726 283.851 10.0282 284.7 10.6278V1.35772Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M420.418 87.3629C420.894 85.9318 421.53 81.6385 419.941 80.2073C419.646 79.9413 417.795 78.657 414.967 76.7434L416.83 89.0487C417.062 89.1592 417.206 89.2356 417.241 89.2711C418.035 90.0664 419.941 88.7941 420.418 87.3629Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M339.629 36.2393C337.73 37.5035 337.901 40.0422 339.966 41.2388L350.768 47.4966C351.713 48.044 352.935 48.0326 353.816 47.4685L355.315 46.509C356.743 45.5945 356.644 43.7091 355.12 42.8133L343.842 36.181C342.536 35.4118 340.835 35.4359 339.629 36.2393Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M227.241 51.2962C227.241 53.6184 224.573 55.5011 221.282 55.5011C217.992 55.5011 215.324 53.6184 215.324 51.2962C215.324 48.9739 217.992 47.0919 221.282 47.0919C224.574 47.0912 227.241 48.9739 227.241 51.2962Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M266.687 112.363C266.487 110.161 253.886 98.3476 253.886 98.3476C253.886 98.3476 261.086 91.74 262.086 89.5377C263.086 87.3355 260.486 76.7233 259.486 75.3224C258.486 73.9207 247.884 67.3132 247.884 67.3132C247.884 67.3132 246.884 60.3057 246.684 59.3047C246.484 58.3037 240.553 50.0942 240.553 50.0942H221.481H203.079C203.079 50.0942 196.478 58.303 196.279 59.3047C196.079 60.3057 195.079 67.3132 195.079 67.3132C195.079 67.3132 184.478 73.9207 183.477 75.3224C182.477 76.724 179.877 87.3355 180.877 89.5377C181.877 91.74 189.077 98.3476 189.077 98.3476C189.077 98.3476 176.476 110.16 176.276 112.363C176.076 114.566 175.076 159.415 175.876 161.217C176.675 163.019 185.476 169.226 186.877 169.626C188.277 170.027 197.878 168.826 198.478 168.625C199.079 168.425 221.481 168.625 221.481 168.625C221.481 168.625 243.883 168.425 244.483 168.625C245.083 168.826 254.684 170.027 256.084 169.626C257.485 169.226 266.286 163.019 267.086 161.217C267.887 159.415 266.887 114.566 266.687 112.363Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M253.886 98.3483C253.886 98.3483 261.087 91.7407 262.087 89.5384C263.087 87.3361 260.487 76.724 259.487 75.323C258.487 73.9214 247.885 67.3139 247.885 67.3139C247.885 67.3139 246.885 60.3063 246.685 59.3053L251.285 94.144L253.886 98.3483Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M265.286 110.071V147.384C265.286 147.384 266.116 148.626 262.701 150.617C259.287 152.608 259.287 152.608 259.287 152.608L263.908 164.337C265.515 163.047 266.804 161.856 267.087 161.217C267.887 159.415 266.887 114.566 266.687 112.363C266.648 111.925 266.112 111.102 265.286 110.071Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M195.08 69.5162L193.28 93.943H195.08L194.88 101.151H249.286V95.3447L251.286 94.1433L248.285 69.3158",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M246.33 101.112L249.286 101.151V95.3446L251.286 94.1433L246.686 59.3047L240.554 50.0948L246.33 101.112Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M202.481 52.2971L197.68 99.7492",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M176.878 135.789C176.878 135.789 180.478 129.582 187.079 131.385C193.68 133.187 194.88 137.792 196.28 140.995C196.941 142.508 198.68 147.402 202.481 150.005C203.738 150.866 238.485 150.005 238.485 150.005C238.485 150.005 240.685 150.005 242.285 147.202C243.886 144.399 249.134 133.763 253.487 131.585C257.887 129.383 262.488 131.986 264.488 134.188",
    fill: "#92E3A9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M176.878 135.789C176.878 135.789 180.478 129.582 187.079 131.385C193.68 133.187 194.88 137.792 196.28 140.995C196.941 142.508 198.68 147.402 202.481 150.005C203.738 150.866 238.485 150.005 238.485 150.005C238.485 150.005 240.685 150.005 242.285 147.202C243.886 144.399 249.134 133.763 253.487 131.585C257.887 129.383 262.488 131.986 264.488 134.188",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M184.978 145.32C188.789 145.32 191.879 142.756 191.879 139.593C191.879 136.431 188.789 133.867 184.978 133.867C181.168 133.867 178.078 136.431 178.078 139.593C178.078 142.756 181.168 145.32 184.978 145.32Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M184.978 136.67C181.751 136.67 179.05 138.511 178.295 140.995C179.049 143.479 181.751 145.32 184.978 145.32C188.206 145.32 190.907 143.479 191.662 140.995C190.908 138.511 188.206 136.67 184.978 136.67Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M257.387 145.32C261.198 145.32 264.287 142.756 264.287 139.593C264.287 136.431 261.198 133.867 257.387 133.867C253.576 133.867 250.487 136.431 250.487 139.593C250.487 142.756 253.576 145.32 257.387 145.32Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.387 136.67C254.159 136.67 251.458 138.511 250.703 140.995C251.457 143.479 254.159 145.32 257.387 145.32C260.614 145.32 263.316 143.479 264.07 140.995C263.316 138.511 260.614 136.67 257.387 136.67Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M267.088 161.218C267.181 161.007 267.25 160.203 267.298 158.954C265.071 156.27 261.313 152.202 259.287 152.608C256.287 153.209 247.886 159.216 245.686 159.616C243.486 160.016 222.483 159.616 222.483 159.616H220.283C220.283 159.616 201.481 160.016 199.281 159.616C197.081 159.215 188.68 153.209 185.679 152.608C182.679 152.008 175.878 161.218 175.878 161.218C176.678 163.02 185.479 169.227 186.879 169.627C188.28 170.028 197.881 168.826 198.481 168.626C199.081 168.426 221.483 168.626 221.483 168.626C221.483 168.626 243.886 168.426 244.486 168.626C245.086 168.826 254.687 170.028 256.087 169.627C257.487 169.226 266.288 163.019 267.088 161.218Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M262.487 160.317C262.487 162.252 260.517 163.821 258.087 163.821C255.657 163.821 253.687 162.252 253.687 160.317C253.687 158.382 255.657 156.812 258.087 156.812C260.517 156.812 262.487 158.382 262.487 160.317Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M189.879 160.317C189.879 162.252 187.909 163.821 185.479 163.821C183.049 163.821 181.079 162.252 181.079 160.317C181.079 158.382 183.049 156.812 185.479 156.812C187.909 156.812 189.879 158.382 189.879 160.317Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M221.483 88.7378C225.791 88.7378 229.284 86.8552 229.284 84.5328C229.284 82.2105 225.791 80.3279 221.483 80.3279C217.174 80.3279 213.682 82.2105 213.682 84.5328C213.682 86.8552 217.174 88.7378 221.483 88.7378Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M193.28 136.813C193.28 136.813 193.68 118.771 193.48 114.766C193.28 110.761 195.68 105.555 195.68 105.555",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M200.881 148.804V112.964",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M240.285 149.204V112.163",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6039 101.921C2.6039 101.921 29.228 127.906 30.8919 128.905C32.5559 129.905 38.2138 132.903 38.2138 132.903",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0.939934 104.587L28.5627 130.571",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M106.771 169.881C106.771 169.881 116.422 178.876 115.757 182.207C115.091 185.538 113.427 187.537 113.427 187.537",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M110.431 168.215C110.431 168.215 120.083 177.21 119.417 180.541C118.752 183.872 117.088 185.872 117.088 185.872",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M74.489 176.877L97.7851 189.869",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4761 184.538L92.4606 189.869",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9095 92.2606L48.5302 118.911",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5627 96.5915L47.5322 114.914",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M440.938 101.921C440.938 101.921 414.314 127.906 412.65 128.905C410.986 129.905 405.328 132.903 405.328 132.903",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M442.602 104.587L414.979 130.571",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M336.771 169.881C336.771 169.881 327.12 178.876 327.785 182.207C328.451 185.538 330.115 187.537 330.115 187.537",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M333.11 168.215C333.11 168.215 323.459 177.21 324.124 180.541C324.79 183.872 326.453 185.872 326.453 185.872",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M369.052 176.877L345.756 189.869",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M361.065 184.538L351.082 189.869",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M423.632 92.2606L395.011 118.911",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M414.979 96.5915L396.01 114.914",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M373.752 46.1278L418.263 75.3559",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M381.586 48.6229L415.058 70.3657",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M361.645 70.3657L411.142 89.2577",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M365.562 74.2865L394.049 84.6233",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M280.812 12.6217L331.733 43.2756",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 20.4634L327.104 43.9891",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M293.275 3.71075L336.006 30.8002",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8512 73.5737L70.3625 46.8407",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3091 46.1278L34.7533 64.6627",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M162.59 13.3346L115.586 42.9192",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M142.293 29.7309L119.859 44.3456",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M147.99 4.78008L104.903 31.1566",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9729 89.9706L79.2647 72.5043",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8898 91.0399L68.9382 79.2767",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDrone);
export default __webpack_public_path__ + "static/media/logo-drone.8fe59b9772278b115af0bb7e312c7a39.svg";
export { ForwardRef as ReactComponent };